import React from "react";
import "../styles/Services.css"; // Make sure this file exists

const services = [
  {
    title: "Electrical Panel Design",
    description: "Custom-designed electrical panels for automation that meet industry standards and specific requirements.",
  },
  {
    title: "System Integration",
    description: "Seamless integration of various automation components to create a cohesive and efficient system.",
  },
  {
    title: "Commissioning",
    description: "Professional commissioning services to ensure that your automation systems operate correctly from day one.",
  },
  {
    title: "PLC Programming",
    description: "Programming services tailored to your industrial automation needs, ensuring optimal control and efficiency.",
  },
  {
    title: "SCADA Systems",
    description: "Complete SCADA solutions for monitoring and controlling industrial processes in real-time.",
  },
  {
    title: "Maintenance & Support",
    description: "Ongoing support and maintenance services to keep your systems running smoothly and minimize downtime.",
  },
];

const Services = () => {
  return (
    <section className="services-section" id="services">
      <div className="services-header">
        <h2>
          Our Comprehensive <span className="highlight">Services</span>
        </h2>
        <p>
          We offer a wide range of automation services to meet your industrial needs, from
          electrical panel design to complete system integration.
        </p>
      </div>

      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <div className="service-icon" />
            <div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
